<template>
  <div>
    <h5 class="font-semibold">
      {{ source }}
    </h5>
    <div>
      Share value: {{ shareValue ? shareValue : 'N/A' }} Dividend:
      {{ dividend != null ? dividend : 'N/A' }}
    </div>
    <a-button v-if="canReportValue" @click="onUseButtonClicked()">
      Use this
    </a-button>
  </div>
</template>

<script>
export default {
  props: {
    source: {
      type: String,
      required: true,
    },
    shareValue: {
      type: Number,
    },
    dividend: {
      type: Number,
    },
    canReportValue: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onUseButtonClicked() {
      this.$emit('useButtonClicked')
    },
  },
}
</script>

<style></style>
